{
  "eyebrow": "Facturare și plată",
  "title": "Aproape gata.",
  "sub": "Continuă către casa securizată pentru a începe perioada de probă de 30 de zile. Nu vei fi taxat astăzi.",
  "summary": {
    "company": "Companie",
    "plan": "Plan",
    "cycle": "Ciclu de facturare",
    "users": "Utilizatori",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Vehicule",
    "total": "Total estimat / lună",
    "vttOn": "Inclus"
  },
  "secureNote": "Casă securizată prin Stripe · 30 de zile de probă · Anulează oricând",
  "continue": "Continuă către Stripe",
  "submitting": "Se deschide Stripe…",
  "canceled": {
    "title": "Plată anulată",
    "sub": "Nu s-a făcut nicio plată. Reîncearcă sau contactează-ne dacă ai nevoie de ajutor.",
    "retry": "Reîncearcă"
  },
  "promo": {
    "toggle": "Ai un cod promoțional?",
    "placeholder": "Cod promoțional",
    "apply": "Aplică",
    "chip": "{{percent}}% reducere",
    "remove": "Elimină codul promoțional",
    "errorGeneric": "Nu am putut verifica codul. Reîncearcă."
  },
  "errors": {
    "generic": "Nu am putut iniția plata. Reîncearcă."
  },
  "totalUnavailable": "Catalog de prețuri indisponibil. Reîncearcă pentru a încărca cele mai noi prețuri."
}
